import S_base from '@/services/wasaapi/__base';
import S_questionType from '@/services/api/v1/questionType';

export default {
  async indexOption() {
    const $_getSingleChoiceId = async () => {
      const res = await S_questionType.index();
      const questionType = res.find(type => type.value === 'single-choice');
      return questionType.id;
    }
    const singleChoiceId = await $_getSingleChoiceId();
    const params = {
      question_type: singleChoiceId,
      type: 'option',
      order_by: 'sequence',
      order_way: 'asc',
    };
    const res = await S_base.index({modelName: 'answer_setting', params});
    return res;
  }
}